// extracted by mini-css-extract-plugin
export default {"root":"ChapterHeader_root__-xLWN","title":"ChapterHeader_title__RXdHI"};